<template>
  <v-text-field
    ref="input"
    v-bind="attrsOnDefault"
    v-model="value"
    type="number"
    @keydown="disableInput($event.key, $event)"
    :class="{
      'input-success': fieldMeta && fieldMeta.validated && fieldMeta.valid,
    }"
  >
    <template v-slot:append-inner v-if="fieldMeta && fieldMeta.validated">
      <v-icon
        v-if="!fieldMeta.valid"
        icon="$mdiInformationOutline"
        size="small"
      />
      <v-icon v-else icon="$mdiCheckBold" size="small" />
    </template>
    <template
      v-for="(slot, index) in slotNames"
      :key="index"
      v-slot:[slot]="props"
    >
      <slot :name="slot" v-bind="props"></slot>
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { FieldMeta } from "vee-validate";

/** b-form-input + 特定の文字列を入力出来ないようにするコンポーネント */
export default defineComponent({
  name: "AppFormInputNumber",
  inheritAttrs: false,
  props: {
    /** true: 小数点入力可能 */
    decimal: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    fieldMeta: {
      type: Object as PropType<FieldMeta<unknown>>,
      required: false,
    },
    modelValue: {
      type: [String, Number] as PropType<string | number>,
      required: false,
    },
  },
  computed: {
    /**
     * slotは公式ページへ参照
     * https://vuetifyjs.com/en/api/v-text-field/#slots
     *
     * 注意:戻り値は"append"[]の形式ではないとTypescriptが型エラーがある
     */
    slotNames(): "append"[] {
      return Object.keys(this.$slots) as [];
    },
    attrsOnDefault(): { [key: string]: unknown } {
      /**
       * VeeValidateのonUpdate:modelValueで値を監視しているので、他のEventをスキップ
       * （Changeイベント二回実行して,nullを空文字に変更してしまう）
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { onInput, onBlur, onChange, ...others } = this.$attrs;

      return others;
    },
    value: {
      get(): unknown {
        return this.modelValue;
      },
      set(newValue: string) {
        if (newValue === "") {
          this.$emit("update:modelValue", null);
        } else {
          this.$emit("update:modelValue", newValue);
        }
      },
    },
  },

  // TODO Vue3 MacのSafariで確認して、問題なさそう
  // OS: Monterey バージョン12.6
  // Safari:バージョン16.0 (17614.1.25.9.10, 17614)
  // mounted() {
  //   // Mac Safari用。keydownでpreventDefaultが効かないのでbeforeinputでpreventDefaultする
  //   (
  //     this.$refs.input as typeof ref<ComponentPublicInstance | null> & {
  //       $el: any;
  //     }
  //   ).$el.addEventListener("beforeinput", (e: Event) => {
  //     return this.disableInput((e as InputEvent).data, e);
  //   });
  // },
  methods: {
    disableInput(key: string | null, e: Event): boolean {
      if (key) {
        if (key.length > 1) {
          // 1文字以上は特殊キー（Backspaceとか）なので何もしない
          return true;
        }

        if (!isNaN(parseInt(key))) {
          return true;
        }

        if (this.decimal) {
          if (key === ".") {
            return true;
          }
        }

        e.preventDefault();
        return false;
      } else {
        return true;
      }
    },
  },
});
</script>
